<div class="dropdown-select" [class.is-disabled]="disabled" (click)="$event.stopPropagation()">
  <button type="button"
          class="dropdown-select__trigger"
          [class.is-open]="isOpen"
          [disabled]="disabled"
          (click)="toggleDropdown($event)">
    <span class="trigger-content">
      @if (selectedIcon) {
        <span class="option-icon" [innerHTML]="selectedIcon"></span>
      }
      <span class="trigger-label">{{ displayLabel }}</span>
    </span>
    <span class="dropdown-arrow" aria-hidden="true">▾</span>
  </button>

  @if (isOpen) {
    <div class="dropdown-select__dropdown" [class.is-upward]="openUpward">
      @if (searchable) {
        <div class="dropdown-select__search">
          <input type="text"
                 [value]="searchTerm"
                 (input)="onSearch($any($event.target).value)"
                 [placeholder]="placeholder">
        </div>
      }
      <div class="dropdown-select__options" [class.is-multiple]="multiple">
        @for (option of filteredOptions; track option.value) {
          <button type="button"
                  (click)="selectOption(option, $event)"
                  [class.is-selected]="isSelected(option.value)"
                  [class.is-disabled]="option.disabled"
                  [disabled]="option.disabled">
            @if (multiple) {
              <input type="checkbox"
                     [checked]="isSelected(option.value)"
                     (click)="$event.stopPropagation()">
            }
            @if (getOptionIcon(option); as icon) {
              <span class="option-icon" [innerHTML]="icon"></span>
            }
            <span class="option-label">{{ option.label }}</span>
          </button>
        }
      </div>
    </div>
  }
</div>
